import React from "react";

function Button({
  onClick,
  children,
  className,
  type = "default",
  size = "medium",
  startIcon,
  endIcon,
}) {
  const baseClasses =
    "p-2 rounded-xl inline-flex items-center font-semibold justify-center";
  const typeClasses = {
    default: "bg-blue-500 font-bold text-sm text-white hover:bg-blue-600",
    ghost: "bg-transparent text-blue-400 hover:opacity-80",
    border: "bg-transparent text-blue-500 border border-blue-500 ",
  };
  const sizeClasses = {
    small: "text-sm py-1 px-2",
    medium: "text-base py-3 px-3",
    large: "text-lg py-3 px-6",
  };

  return (
    <button
      onClick={onClick}
      className={`${baseClasses} ${typeClasses[type]} ${sizeClasses[size]} ${className}`}
    >
      {startIcon && <span className="mr-2">{startIcon}</span>}
      {children}
      {endIcon && <span className="ml-2">{endIcon}</span>}
    </button>
  );
}

export default Button;
